import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';



@Component({
  selector: 'app-app-layout',
  templateUrl: './layout.html',
  styleUrls: []
})
export class AppLayoutComponent implements AfterViewInit {

  constructor() {
    
  }
  ngAfterViewInit(): void {
    
  }
  
}



// WEBPACK FOOTER //
// ./src/app/layout/layout.component.ts